/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.gatewayModel', [])
    .factory('gatewayModelService', GatewayModelService)
    .name;

/*@ngInject*/
function GatewayModelService($http, $q) {

    var service = {
        deleteGatewayModel: deleteGatewayModel,
        getGatewayModel: getGatewayModel,
        getSystemGatewayModel: getSystemGatewayModel,
        saveGatewayModel: saveGatewayModel,
        getProviderGatewayModels: getProviderGatewayModels
    }

    return service;

    function getProviderGatewayModels () {
        var deferred = $q.defer();
        $http.get('/api/provider/gatewayModels', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getGatewayModel (gatewayModelId) {
        var deferred = $q.defer();
        var url = '/api/gatewayModel/' + gatewayModelId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSystemGatewayModel(gatewayModelId) {
        var deferred = $q.defer();
        var url = '/api/system/gatewayModel/' + gatewayModelId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveGatewayModel (gatewayModel) {
        var deferred = $q.defer();
        var url = '/api/gatewayModel';
        $http.post(url, gatewayModel).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteGatewayModel (gatewayModelId) {
        var deferred = $q.defer();
        var url = '/api/gatewayModel/' + gatewayModelId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/gateway-model.service.js